import { initMainMenu } from "./main-menu.js";

initMainMenu();
